import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Toast } from '../../../core/interfaces/toast';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  selector: 'app-toast',
  standalone: true,
  imports: [CommonModule, TranslocoPipe],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.css'
})
export class ToastComponent {
  listOfToasts: Toast[] = [];
  private counter = 0;

  showToast(title: string, message: string, type: 'success' | 'error' | 'warning' = 'success', duration: number = 3000, autoTranslate: boolean = true) {
    const id = this.counter++;
    this.listOfToasts.push({ id, title, message, type, autoTranslate });

    setTimeout(() => {
      this.listOfToasts = this.listOfToasts.filter(toast => toast.id !== id);
    }, duration);

    return id;
  }

  updateToast(id: number, title: string, message: string, type: 'success' | 'error' | 'warning' = 'success', autoTranslate: boolean = true) {
    var findToastIndex: number | null = this.listOfToasts.findIndex(t => t.id === id);
    if (findToastIndex === -1) return false;

    const updated = { id, title, message, type, autoTranslate };

    // Trigger UI update
    this.listOfToasts = [
      ...this.listOfToasts.slice(0, findToastIndex),
      updated,
      ...this.listOfToasts.slice(findToastIndex + 1),
    ];

    return true;
  }
}
